import { createApp } from 'vue';
import FindSrfConsultantApp from '../App/FindSrfConsultantApp.vue';

const appElement = document.getElementById('vue-findSrfConsultantApp');

if (!appElement) {
  throw new Error('Missing required element');
}

const pageId = Number(appElement.dataset.pageId);
const locale = appElement.dataset.locale || 'sv-SE';

if (!pageId) {
  throw new Error('Missing pageId');
}

createApp(FindSrfConsultantApp, { pageId, locale }).mount('#vue-findSrfConsultantApp');
